/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const loadingConfig = {
  buyInsuranceLoading: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.logos/vlinder-logo.png',
    titleNormalText: 'Loading',
    titleBoldText: '...',
    description: 'This might take few seconds, Please wait !',
  },
  GetPageLoading: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
    titleNormalText: 'Loading',
    titleBoldText: '...',
    description: 'This might take few seconds, Please wait !',
  },
  verifyOTP: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
    titleNormalText: 'Verifying OTP',
    titleBoldText: '...',
    description: 'This might take few seconds, Please wait !',
  },
  submitKYC: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
    titleNormalText: 'Updating Know Your Customer (KYC)',
    titleBoldText: 'details...',
    description: 'This might take few seconds, Please wait !',
  },
  purchasePolicy: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
    titleNormalText: 'Processing Payment',
    titleBoldText: '...',
    description:
      'Connecting to payment gateway. Please complete your payment in the secure Razorpay window. Please do not refresh or close this page.',
  },
  paymentProcessing: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
    titleNormalText: 'Processing Payment',
    titleBoldText: '...',
    description:
      'Connecting to payment gateway. Please complete your payment in the secure Razorpay window. Please do not refresh or close this page.',
  },
  policyIssuing: {
    image:
      'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
    titleNormalText: 'Thank you for your payment! ',
    titleBoldText: 'Issuing your policy...',
    description:
      'Your policy is being issued and confirmed. Please wait a few seconds !',
  },
};
